import React from 'react'
import {Card, CardActionButton, CardHeader, FieldRequirements, SignInLayout} from '../components/SigninLayout'
import {Errors, validation, WithForm} from '@startlibs/form'
import {useToggle} from '@startlibs/core'
import {formFetch} from '@startlibs/utils'
import {confirmPasswords, minLength, required} from '../lib/validation'
import {PasswordInput} from '../components/PasswordInput'
import {FormattedMessage, useIntl} from "react-intl";

// http://localhost:9000/redefine-password?key=58365593372806686968&systemId=startlabs



const onSuccess = (system, keepLoading, autoLogin, successMsg, intl) => (_, {id_token}) => {
  keepLoading.open()
  if(autoLogin === 'false'){
    successMsg.open()
  }else{
    window.location = system.systemWebHooks.systemAuthWebHook + id_token + "&locale=" + intl.locale
  }
}

export const RedefinePasswordForm = ({system, header, tokenKey, autoLogin}) => {
  const keepLoading = useToggle()
  const visiblePassword = useToggle()
  const successMsg = useToggle()
  const intl = useIntl()
  const preValidate = validation.buildValidation({
      confirmPassword: confirmPasswords(intl,'password'),
      password: [required(intl), minLength(intl,8)]
    }
  )

  const onFailure = validation.responseFailure(
    ({message, title, type}) =>
      (title === 'passwordCannotBeEqualToThePreviousPasswords' && {password: [intl.formatMessage({
          defaultMessage: `Your new password must be different from your previous {pwdInHistory} passwords.`,
          description: 'Redefine password, repeated password error'},
          {
            pwdInHistory: system.systemAuthPolicy.pwdInHistory
          })]}) ||
      (type === 'https://pas.purview.net/problem/invalid-password' && {password: []}) ||
      (message === "error.keyExpired" && {'': [<span><FormattedMessage
          defaultMessage="This page has expired. Please <a>request a new recovery link</a> and try again."
          description="Redefine password, expired page error"
          values={{
            a: (chunks) => <a href={"/recovery?systemId="+system.systemId}>{chunks}</a>
          }}
        /></span>]})
  )

  return <Card>
    {header && header()}
    <WithForm
      action={formFetch("/pasapi/account/reset-password/finish")}
      onFailure={onFailure}
      values={{key:tokenKey}}
      onSuccess={onSuccess(system, keepLoading, autoLogin, successMsg, intl)}
      preValidation={preValidate}
    >{(form) => <>
        <PasswordInput
          mandatory
          syncVisible={visiblePassword}
          path="password"
          name="password"
          label={intl.formatMessage({
            defaultMessage: "New password",
            description: "Redefine password, new password label"
          })}
        />
        <PasswordInput
          mandatory
          syncVisible={visiblePassword}
          path="confirmPassword"
          name="confirmPassword"
          label={intl.formatMessage({
            defaultMessage: "Confirm password",
            description: "Redefine password, confirm password label"
          })}
        />
        <FieldRequirements hasErrors={form.hasErrors('password')}>
        <FormattedMessage
          defaultMessage="Your new password must be <b>{pwdMinimumLength} or more characters</b>, containing at least <b>one uppercase letter</b>, one <b>number</b> and one <b>special character</b>"
          description="Password requirements"
          values={{
            pwdMinimumLength: system.systemAuthPolicy.pwdMinimumLength,
            b: msg => <b>{msg}</b>
          }}
        />
        </FieldRequirements>
        <Errors />
        {!successMsg.isOpen && <CardActionButton highlight isLoading={form.isLoading || keepLoading.isOpen} type="submit">
          {autoLogin === "false" ? intl.formatMessage({
            defaultMessage: "Save",
            description: "Redefine password, save button"
          }): intl.formatMessage({
            defaultMessage:"Save and sign in",
            description: "Redefine password, save and sign in button"
          })}
        </CardActionButton>
        }
        {
          successMsg.isOpen &&
          <ul className="successContainer">
            <li>
              <span><FormattedMessage
                defaultMessage="Success! Your password has been updated."
                description="Redefine password, success message"
              /></span>
            </li>
          </ul>
        }
    </>}</WithForm>
  </Card>
}


export const RedefinePassword = (props) =>
  <SignInLayout system={props.system}>
    <RedefinePasswordForm
      {...props}
      tokenKey={new URLSearchParams(window.location.search).get('key')}
      header={() =>
        <CardHeader>
          <h1><FormattedMessage
            defaultMessage="Define new password"
            description="Redefine password title"
          /></h1>
          <p><FormattedMessage
            defaultMessage="Enter and confirm your new password below"
            description="Redefine password instructions"
          /></p>
        </CardHeader>
      }
    />
  </SignInLayout>
